import Vue from 'vue'

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Buefy from 'buefy'
// import 'buefy/lib/buefy.css'
Vue.use(Buefy, {
  defaultIconPack: 'fa',
})

import Tooltip from 'vue-directive-tooltip';
Vue.use(Tooltip);

import VueAxios from 'vue-axios';
import axios from 'axios';
Vue.use(VueAxios, axios);

const App = () => import(/* webpackChunkName: "app" */ './App.vue');
const AddIn = () => import(/* webpackChunkName: "add-in" */ './AddIn.vue');

const OfficeUIFabricVue = () => import(/* webpackChunkName: "office-ui-fabric-vue" */ 'office-ui-fabric-vue');

// Default app settings
let appEl = '#app';
let app = App;

// Add-in app settings
if (document.getElementById('add-in')) {
  Vue.use(OfficeUIFabricVue);

  appEl = '#add-in';
  app = AddIn;
}

new Vue({
  el: appEl,
  render: h => h(app)
})



// WEBPACK FOOTER //
// ./src/main.js